module.exports = __webpack_public_path__ + "img/9.b7a9a2dc.jpg";